import React, { Component } from 'react';

class Button extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (<button {...this.props} />);
    }
}

class LoadingPanel extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
        );
    }
}



export const Input = ({ input, label, className, type, meta: { touched, error, warning } }) => (
    <div className={"form-group" + (touched && error ? " has-error" : "")}>
        <div>
            <input {...input} className={className} placeholder={label} type={type} />
            {touched && ((error && <span className="help-block">{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
)

export default { Button: Button, LoadingPanel: LoadingPanel };


// WEBPACK FOOTER //
// ./app/util/controls.js